import React, { useState } from 'react';
import { FaPhoneAlt, FaMapMarkerAlt, FaChevronUp } from 'react-icons/fa';

function FloatingMenu() {
    const [showPopup, setShowPopup] = useState(false);

    const menuStyle = {
        position: 'fixed',
        bottom: '40px',
        right: '40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        zIndex: 9999
    };

    const baseButtonStyle = {
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: '#FFF',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        fontSize: '22px',
        color: '#444',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: 0
    };

    const coloredButtonStyle = {
        ...baseButtonStyle,
        backgroundColor: '#98bcc9'
    };

    const topButtonStyle = {
        ...baseButtonStyle,
        flexDirection: 'column',
        fontSize: '20px'
    };

    const topTextStyle = {
        fontSize: '12px',
        fontWeight: 'bold',
        marginTop: '2px',
        lineHeight: '1'
    };

    const popupStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000
    };

    const popupBoxStyle = {
        backgroundColor: 'white',
        borderRadius: '16px',
        overflow: 'hidden',
        maxWidth: '380px',
        width: '90%',
        boxShadow: '0 8px 20px rgba(0,0,0,0.3)'
    };

    const popupHeaderStyle = {
        backgroundColor: '#3a3d41',
        color: '#fff',
        padding: '20px',
        textAlign: 'left',
        fontSize: '18px',
        fontWeight: 'bold',
        lineHeight: '1.2'
    };

    const popupBodyStyle = {
        padding: '24px 20px 30px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#444'
    };

    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleMapRedirect = () => {
        window.location.href = '/location';
    };

    return (
        <>
            <div style={menuStyle}>
                <button style={coloredButtonStyle} onClick={() => setShowPopup(true)}>
                    <FaPhoneAlt />
                </button>
                <button style={coloredButtonStyle} onClick={handleMapRedirect}>
                    <FaMapMarkerAlt />
                </button>
                <button style={topButtonStyle} onClick={handleScrollTop}>
                    <FaChevronUp />
                    <span style={topTextStyle}>TOP</span>
                </button>
            </div>

            {showPopup && (
                <div style={popupStyle} onClick={() => setShowPopup(false)}>
                    <div style={popupBoxStyle} onClick={(e) => e.stopPropagation()}>
                        <div style={popupHeaderStyle}>
                            <div>전화번호</div>
                        </div>
                        <div style={popupBodyStyle}>
                            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                                아이엠플러스교육심리센터
                            </h2>
                            <div style={{ color: '#2ecc71', fontSize: '18px', marginTop: '8px' }}>
                                031-928-7329
                            </div>
                            <p style={{ fontSize: '13px', color: '#888' }}>
                                전화 연결은 모바일에서 가능합니다.
                            </p>
                            <button
                                onClick={() => setShowPopup(false)}
                                style={{
                                    marginTop: '16px',
                                    backgroundColor: '#333',
                                    color: '#fff',
                                    padding: '8px 20px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default FloatingMenu;
